import { AchievementDropdown } from "components/Campaign/CampaignConditions/AchievementDropdown";
import { ArrayCondition } from "components/Campaign/CampaignConditions/ArrayCondition";
import { Bool } from "components/Campaign/CampaignConditions/Bool";
import { ChannelDropdown } from "components/Campaign/CampaignConditions/ChannelDropdown";
import { CountryDropdown } from "components/Campaign/CampaignConditions/CountryDropdown";
import { Date } from "components/Campaign/CampaignConditions/Date";
import { DateTime } from "components/Campaign/CampaignConditions/DateTime";
import { Expression } from "components/Campaign/CampaignConditions/Expression";
import { Float } from "components/Campaign/CampaignConditions/Float";
import { GenderDropdown } from "components/Campaign/CampaignConditions/GenderDropdown";
import { Int } from "components/Campaign/CampaignConditions/Int";
import { ItemsCriteria } from "components/Campaign/CampaignConditions/ItemsCriteria";
import { Label } from "components/Campaign/CampaignConditions/Label";
import { SegmentDropdown } from "components/Campaign/CampaignConditions/SegmentDropdown";
import { String } from "components/Campaign/CampaignConditions/String";
import { TierDropdown } from "components/Campaign/CampaignConditions/TierDropdown";
import { TransactionType } from "components/Campaign/CampaignConditions/TransactionType";
import { CampaignConditionType } from "types/campaigns";

export function AttributeSection({
  disabled,
  type,
  status,
  fieldName,
  index,
  ruleIndex,
  isAchievementForm,
  shouldSuppressHj,
}: {
  disabled?: boolean;
  type?: CampaignConditionType;
  status?: any;
  fieldName: string;
  index?: number;
  ruleIndex?: number;
  isAchievementForm?: boolean;
  shouldSuppressHj?: boolean;
}) {
  return (
    <>
      {type &&
        {
          achievementDropdown: (
            <AchievementDropdown
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
            />
          ),
          array: <ArrayCondition fieldName={fieldName} />,
          boolean: <Bool fieldName={fieldName} />,
          date: <Date fieldName={fieldName} />,
          datetime: <DateTime fieldName={fieldName} />,
          expression: <Expression fieldName={fieldName} />,
          float: <Float fieldName={fieldName} />,
          int: <Int fieldName={fieldName} />,
          label: (
            <Label
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
            />
          ),
          number: <Float fieldName={fieldName} />,
          text: (
            <String
              fieldName={fieldName}
              status={status?.[fieldName]}
              index={index}
              ruleIndex={ruleIndex}
              isAchievementForm={isAchievementForm}
              shouldSuppressHj={shouldSuppressHj}
            />
          ),
          tierDropdown: (
            <TierDropdown
              disabled={disabled}
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
            />
          ),
          tierDropdownSingle: (
            <TierDropdown
              disabled={disabled}
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
              multiple={false}
            />
          ),
          channelDropdown: (
            <ChannelDropdown
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
            />
          ),
          genderDropdown: (
            <GenderDropdown
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
            />
          ),
          countryDropdown: (
            <CountryDropdown
              fieldName={fieldName}
              isAchievementForm={isAchievementForm}
            />
          ),
          segmentDropdown: <SegmentDropdown fieldName={fieldName} />,
          transactionType: <TransactionType fieldName={fieldName} />,
          itemsCriteria: (
            <ItemsCriteria
              fieldName={fieldName}
              ruleIndex={ruleIndex!}
              index={index!}
            />
          ),
        }[type]}
    </>
  );
}
